module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0